export const RECORD_KIND = 11111;
export const ZONE_HANDLER_KIND = 31990;
export const DEFAULT_ZONE = 'nodns.shop';
export const DEFAULT_API_BASE = 'https://nodns.shop';
export const DEFAULT_DOH_ENDPOINT = 'https://cloudflare-dns.com/dns-query';
export const DEFAULT_READ_RELAYS = [
    'wss://relay.cashu.email',
    'wss://relay.damus.io',
    'wss://nos.lol',
    'wss://relay.nostr.band',
    'wss://relay.tollgate.me',
];
export const VALID_RECORD_TYPES = ['A', 'AAAA', 'CNAME', 'TXT', 'MX'];
export const DNS_TYPE_MAP = {
    1: 'A',
    28: 'AAAA',
    5: 'CNAME',
    16: 'TXT',
    15: 'MX',
    2: 'NS',
    6: 'SOA',
};
